import { SelectOptions } from '@/model/CommonModel';
import type { MenuProps } from 'antd';
import { Button, Dropdown, Space } from 'antd';
import React from 'react';
import styles from './buttonDropdown.module.scss';

type Props<T> = {
	labelIcon?: string | React.ReactElement;
	onClickOption?: (value: T) => void;
	menuOptions: SelectOptions<T>[];
	icon?: React.ReactElement;
	disabled?: boolean;
	id?: string;
	overlayClassName?: string;
	useParentAsPopupContainer?: boolean;
	destroyPopupOnHide?: boolean;
};

const ButtonDropdown = <T extends object | string | number>({
	onClickOption,
	menuOptions,
	labelIcon,
	icon,
	disabled,
	id,
	overlayClassName,
	destroyPopupOnHide,
	useParentAsPopupContainer = true,
}: Props<T>) => {
	const items: MenuProps['items'] = menuOptions.map(({ icon, id, key, label, leaveTab, separator, title, value, disabled }, index) => ({
		className: separator ? styles.separator : undefined,
		['data-leavetab']: leaveTab,
		icon,
		id,
		key: `${label}-${index}`,
		label: <span data-leavetab={leaveTab}>{label}</span>,
		onClick: () => onClickOption?.(value),
		title,
		disabled,
	}));

	return (
		<>
			{disabled ? (
				<Button id={id} disabled={disabled}>
					{labelIcon}
					{icon}
				</Button>
			) : (
				<Dropdown
					menu={{ items }}
					disabled={disabled}
					overlayClassName={overlayClassName}
					getPopupContainer={(triggerNode: HTMLElement) => (useParentAsPopupContainer && (triggerNode?.parentNode as HTMLElement)) || document.body}
					overlayStyle={{ width: 'max-content' }}
					destroyPopupOnHide={destroyPopupOnHide}>
					<Button id={id}>
						<Space>
							{labelIcon}
							{icon}
						</Space>
					</Button>
				</Dropdown>
			)}
		</>
	);
};

export { ButtonDropdown };
